export const spotifySongs = [
    { title: "Starboy", artist: "The Weeknd, Daft Punk" },           // 1
    { title: "Blinding Lights", artist: "The Weeknd" },               // 2
    { title: "Levitating", artist: "Dua Lipa" },                      // 3
    { title: "Cruel Summer", artist: "Taylor Swift" },                // 4
    { title: "As It Was", artist: "Harry Styles" },                   // 5
    { title: "Anti-Hero", artist: "Taylor Swift" },                   // 6
    { title: "Heat Waves", artist: "Glass Animals" },                 // 7
    { title: "Good 4 U", artist: "Olivia Rodrigo" },                  // 8
    { title: "Watermelon Sugar", artist: "Harry Styles" },            // 9
    { title: "Bad Guy", artist: "Billie Eilish" },                    // 10
    { title: "Creepin'", artist: "Metro Boomin, The Weeknd" },        // 11
    { title: "Kill Bill", artist: "SZA" },                            // 12
    { title: "Unholy", artist: "Sam Smith, Kim Petras" },             // 13
    { title: "Shape of You", artist: "Ed Sheeran" },                  // 14
    { title: "Dance Monkey", artist: "Tones And I" },                 // 15
    { title: "Save Your Tears", artist: "The Weeknd" },               // 16
    { title: "Stay", artist: "The Kid LAROI, Justin Bieber" },        // 17
    { title: "Peaches", artist: "Justin Bieber" },                    // 18
    { title: "Montero", artist: "Lil Nas X" },                        // 19
    { title: "Water", artist: "Tyla" },                               // 20
    { title: "Calm Down", artist: "Rema, Selena Gomez" },             // 21
    { title: "Flowers", artist: "Miley Cyrus" },                      // 22
    { title: "Vampire", artist: "Olivia Rodrigo" },                   // 23
    { title: "Paint The Town Red", artist: "Doja Cat" },              // 24
    { title: "Sprinter", artist: "Dave, Central Cee" },               // 25
    { title: "Boy's a liar Pt. 2", artist: "PinkPantheress" },        // 26
    { title: "Golden Hour", artist: "JVKE" },                         // 27
    { title: "Rich Flex", artist: "Drake, 21 Savage" },               // 28
    { title: "First Class", artist: "Jack Harlow" },                  // 29
    { title: "Pink + White", artist: "Frank Ocean" },                 // 30
    { title: "Nights", artist: "Frank Ocean" }                        // 31 (covering max days in month)
];
